const  IconDownload= () => {

    return (

        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 5V11H11V5" stroke="white"/>
            <path d="M6 8V0" stroke="white"/>
            <path d="M3.5 6L6 8.5L8.5 6" stroke="white"/>
        </svg>
    )

}

export default IconDownload;
